module.exports = __webpack_public_path__ + "static/media/letter_g.94be47fa.m4a";